import { render } from "./agent-review.vue?vue&type=template&id=39026b67"
import script from "./agent-review.js?vue&type=script&lang=js"
export * from "./agent-review.js?vue&type=script&lang=js"

import "./agent-review.vue?vue&type=style&index=0&id=39026b67&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__